import React from "react";
import { createRoot } from "react-dom/client";

// Framework CSS
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";

// Estilos globales (después de Bootstrap para que puedan sobreescribirlo)
import "./styles/index.css";
import "./styles/theme-premium.css";
import "./styles/ui-components.css";

// Punto de entrada principal
import App from "./App.js"; // ✅ usa .js en lugar de .jsx

// Tema: respeta preferencia guardada, si no usa preferencia del sistema
const savedTheme = localStorage.getItem("sw-theme");
const prefersDark = window.matchMedia("(prefers-color-scheme: dark)").matches;
document.documentElement.setAttribute("data-theme", savedTheme || (prefersDark ? "dark" : "light"));

const root = createRoot(document.getElementById("root"));
root.render(<App />);

// Retirar el service worker antiguo que podia mantener una version obsoleta
// de la tabla incluso despues de un despliegue correcto.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", async () => {
    try {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((registration) => registration.unregister()));
      if ("caches" in window) {
        const cacheNames = await caches.keys();
        await Promise.all(
          cacheNames
            .filter((name) => name.startsWith("sw-studio-") || name.startsWith("specialwash-"))
            .map((name) => caches.delete(name))
        );
      }
    } catch (error) {
      console.warn("No se pudo retirar el cache antiguo de la aplicacion", error);
    }
  });
}
